// extracted by css-extract-rspack-plugin
var _1 = "gf";
var _2 = "fi";
var _3 = "fm";
var _4 = "ge";
var _5 = "gh";
var _6 = "gg";
var _7 = "gi";
var _8 = "e0";
export { _1 as "descriptionSection", _2 as "descriptionText", _3 as "discountCouponComponent", _4 as "discountCouponMobileOnly", _5 as "mobileAppLink", _6 as "mobileApps", _7 as "separator", _8 as "title" }
